import Accordion from "../gdk/Accordion/Accordion";
import { useEffect, useState, useRef } from "react";
import ExpandableFormList from "../gdk/ExpandableForm/ExpandableFormList";
import ExpandableFormListItem from "../gdk/ExpandableForm/ExpandableFormListItem";
import AdditionalInformationForm, { AssociationsOptions, IncentivesContactOptions, IncentivesParticipationOptions, BusinessRelationshipsOptions } from "./AdditionalInformationForm";
import AgencyDetails from "./AgencyDetails";
import QuoteAndPolicyManagementSystemsForm, { AgencyManagementSystemOptions, ComparativeRaterOptions, IvansDownloadsOptions } from "./QuoteAndPolicyManagementSystemsForm";
import { getAgencyProfile } from "../../api/agency-profile";
import Loader from "../gdk/Loader";
import { LANGUAGE_OPTIONS } from "@geicoap/ia-shared";

export default function AgencyProfile({
    agencyId,
}) {
    const [agencyProfile, setAgencyProfile] = useState();

    useEffect(() => {
        getAgencyProfile(agencyId, response => setAgencyProfile(response));
    }, []);


    const additionalInformationSummary = (agencyProfile) => {
        const additionalInformation = [
            { name: "Associations", value: agencyProfile.associations?.map((l) => AssociationsOptions().find((o) => o.value === l).text).join(", ") },
            { name: "Business Relationships", value: agencyProfile.maps?.map((x) => BusinessRelationshipsOptions().find((o) => o.value === x.name)?.text).join(", ") },
            { name: "Business City or County", value: agencyProfile.businessAddress?.city ?? agencyProfile.businessAddress?.county },
            { name: "Rewards Participation", value: IncentivesParticipationOptions().find((o) => o.value === agencyProfile.marketingIncentives?.incentivesParticipation)?.label },
            { name: "Languages", value: agencyProfile.languages?.map((l) => LANGUAGE_OPTIONS.find((o) => o.value === l)?.label ?? l).join(", ") },
            { name: "Website", value: agencyProfile.website }
        ]
        const incentivesParticipation = IncentivesParticipationOptions().find((o) => o.value === agencyProfile.marketingIncentives?.incentivesParticipation)?.label;

        if (incentivesParticipation === "Yes") {
            const incentivesContact = { name: "Rewards Participation Level", value: IncentivesContactOptions().find((o) => o.value === agencyProfile.marketingIncentives?.incentivesContact)?.text };
            additionalInformation.splice(4, 0, incentivesContact);
        }

        return additionalInformation;
    };

    const quoteAndPolicyManagementSystemsSummary = (agencyProfile) => [
        { name: "Agency Management System", value: AgencyManagementSystemOptions().find((o) => o.value === agencyProfile.agencyManagementSystem)?.text },
        { name: "Comparative Rater", value: ComparativeRaterOptions().find((o) => o.value === agencyProfile.compRater)?.text },
        { name: "IVANS Downloads", value: IvansDownloadsOptions().find((o) => o.value === agencyProfile.ivans?.isIvansEnabled)?.label },
        { name: "IVANS Account ID", value: agencyProfile.ivans?.ivansAccountId },
        { name: "IVANS User ID", value: agencyProfile.ivans?.ivansUserId }
    ];

    const [additionalInfoExpandableForm, setAdditionalInfoExpandableForm] = useState();
    const [quoteAndPolicyExpandableForm, setQuoteAndPolicyExpandableForm] = useState();
    const rewardsParticipationLevelSuccessToastRef = useRef();

    return (
        <>
            {!agencyProfile && <Loader />}

            {agencyProfile &&
                <>
                    <Accordion id="agency-details">
                        <AgencyDetails agencyProfile={agencyProfile}
                            setAgencyProfile={setAgencyProfile}
                            onSave={(updatedProfile) => setAgencyProfile(updatedProfile)}
                            onCancel={() => console.log('Cancel')}
                        />
                    </Accordion>
                    <ExpandableFormList setExpandableForm={setAdditionalInfoExpandableForm} >
                        <ExpandableFormListItem
                            id="additional-information-form-li"
                            headline="Additional Information"
                            editable={true}
                            summaryItems={additionalInformationSummary(agencyProfile)}
                            form={<AdditionalInformationForm
                                agencyProfile={agencyProfile}
                                setAgencyProfile={setAgencyProfile}
                                expandableForm={additionalInfoExpandableForm}
                                rewardsParticipationLevelSuccessToastRef={rewardsParticipationLevelSuccessToastRef}
                            />}
                        />
                        <gds-toast type="success" time-limit="" ref={rewardsParticipationLevelSuccessToastRef}>
                            <span slot="toast-subtext">Rewards Participation Level has been successfully updated.</span>
                        </gds-toast>
                    </ExpandableFormList>
                    <ExpandableFormList setExpandableForm={setQuoteAndPolicyExpandableForm} >
                        <ExpandableFormListItem
                            id="quote-and-policy-form-li"
                            headline="Quote and Policy Management Systems"
                            editable={true}
                            summaryItems={quoteAndPolicyManagementSystemsSummary(agencyProfile)}
                            form={<QuoteAndPolicyManagementSystemsForm
                                agencyProfile={agencyProfile}
                                setAgencyProfile={setAgencyProfile}
                                expandableForm={quoteAndPolicyExpandableForm}
                            />}
                        />
                    </ExpandableFormList>
                </>
            }
        </>
    );
};

const AddressString = (a) => a ? `${a.street1}, ${a.city}, ${a.state}, ${a.zipCode}` : "";
